/**
 * Libellés qualitatifs des scores 0–100 (synthèse, rapport, onglets projet).
 *
 * Règles :
 * - ≥ 90 → Excellent
 * - 81–89 → Très bon
 * - 60–80 → Bon
 * - 50–59 → Moyen (palier intermédiaire, orange foncé)
 * - 40–49 → À améliorer
 * - < 40 → Critique
 */

export function getScoreQualitative(score) {
  const n = Math.round(Number(score) || 0);
  if (!n) {
    return {
      label: 'Non audité',
      color: 'text-blue-gray-400',
      bg: 'bg-blue-gray-50',
      ring: '#cbd5e1',
      tone: 'neutre',
    };
  }
  if (n >= 90) {
    return {
      label: 'Excellent',
      color: 'text-green-700',
      bg: 'bg-green-50',
      ring: '#22c55e',
      tone: 'positif',
    };
  }
  if (n > 80) {
    return {
      label: 'Très bon',
      color: 'text-emerald-700',
      bg: 'bg-emerald-50',
      ring: '#34d399',
      tone: 'positif',
    };
  }
  if (n >= 60) {
    return {
      label: 'Bon',
      color: 'text-amber-700',
      bg: 'bg-amber-50',
      ring: '#f59e0b',
      tone: 'correct',
    };
  }
  if (n >= 50) {
    return {
      label: 'Moyen',
      color: 'text-orange-900',
      bg: 'bg-orange-100',
      ring: '#c2410c',
      tone: 'moyen',
    };
  }
  if (n >= 40) {
    return {
      label: 'À améliorer',
      color: 'text-orange-700',
      bg: 'bg-orange-50',
      ring: '#f97316',
      tone: 'faible',
    };
  }
  return {
    label: 'Critique',
    color: 'text-red-700',
    bg: 'bg-red-50',
    ring: '#ef4444',
    tone: 'critique',
  };
}

/** Alias court pour les pastilles / exports texte. */
export function getScoreLabelText(score) {
  return getScoreQualitative(score).label;
}
